// Automatic Delivery Date Calculator
document.addEventListener('DOMContentLoaded', function() {
  // Calculate delivery date (4 days from today)
  const today = new Date();
  const deliveryDate = new Date(today);
  deliveryDate.setDate(today.getDate() + 4);
  
  // Format the date in Indian format
  const day = deliveryDate.getDate();
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                  'July', 'August', 'September', 'October', 'November', 'December'];
  const month = months[deliveryDate.getMonth()];
  const year = deliveryDate.getFullYear();
  
  const formattedDate = `${day} ${month} ${year}`;
  
  // Update delivery date element
  const deliveryDateElement = document.getElementById('delivery-date');
  if (deliveryDateElement) {
    deliveryDateElement.textContent = formattedDate;
  }
});
